import axiosInstance from "./AxiosConfig";
import {REST_API_BASE_URL_REMOTE} from '../services/PathEnvironment'

const REST_API_BASE_URL = REST_API_BASE_URL_REMOTE + 'api/posts';

// Keywords go in the URL path: encode them, otherwise "C#", "UI/UX" or "R&D" break the request.
const enc = (value) => encodeURIComponent(String(value ?? '').trim());

export const listPosts = (page, size, sort) => axiosInstance.get(REST_API_BASE_URL, { params: { page, size, sort: `${sort},desc` } });

export const listPseoPosts = (role, nation, remote, page, size) => axiosInstance.get(REST_API_BASE_URL + '/search/pseo', { params: { role: role || '', nation: nation || '', remote: Boolean(remote), page, size, sort: 'insertData,desc' } });

export const listFilterPosts = (key, page, size, withDescription, sort, ascDesc) => axiosInstance.get(REST_API_BASE_URL + '/' + enc(key), { params: { page, size, withDescription: Boolean(withDescription), sort: `${sort},${ascDesc}` } });

/**
 * Server-side search with every filter (keyword, remote, nation, city).
 * filters: { keyword, withDescription, remote, placeId, nationTag, nationId, nationName }
 */
export const searchPostsAdvanced = (filters, page, size, sort, direction) => axiosInstance.get(REST_API_BASE_URL + '/search/advanced', { params: { ...cleanParams(filters), page, size, sort: `${sort},${direction}` } });

export const createPost = (post) => axiosInstance.post(REST_API_BASE_URL, post);

export const getPost = (postId) => axiosInstance.get(REST_API_BASE_URL + '/post/' + postId);

export const updatePost = (postId, post) => axiosInstance.put(REST_API_BASE_URL + '/' + postId, post);

export const listYourPosts = (userId, page, size, sort) => axiosInstance.get(REST_API_BASE_URL + '/user/' + userId, { params: { page, size, sort: `${sort},desc` } });

export const deletePost = (postId, userId) => axiosInstance.delete(REST_API_BASE_URL + '/' + postId + '/' + userId);

export const addFavouritePost = (favouritePost) => axiosInstance.post(REST_API_BASE_URL + '/favourites/favourite', favouritePost);

export const removeFavouritePost = (favouritePost) => axiosInstance.delete(REST_API_BASE_URL + '/favourites/favourite', { data: favouritePost });

export const removeAllFavouritePosts = (userId) => axiosInstance.delete(REST_API_BASE_URL + '/favourites/' + userId);

export const removeAllYourPosts = (userId) => axiosInstance.delete(REST_API_BASE_URL + '/all/' + userId);

export const listUserFavouritePosts = (userId, page, size, sort) => axiosInstance.get(REST_API_BASE_URL + '/favourites/' + userId, { params: { page, size, sort: `${sort},desc` } });

export const listUserFilterFavouritePosts = (key, userId, page, size, sort, ascDesc) => axiosInstance.get(REST_API_BASE_URL + '/favourites/' + enc(key) + "/" + userId, { params: { page, size, sort: `${sort},${ascDesc}` } });

export const listUserFilterPosts = (key, userId, page, size, sort, ascDesc) => axiosInstance.get(REST_API_BASE_URL + '/user/' + enc(key) + "/" + userId, { params: { page, size, sort: `${sort},${ascDesc}` } });

export const addUserView = (postId) => axiosInstance.post(REST_API_BASE_URL + '/user/view/' + postId);

export const increaseJobSubmission = (postId) => axiosInstance.post(REST_API_BASE_URL + '/' + postId + '/submissions');

export function cleanParams(obj = {}) {
    return Object.fromEntries(
        Object.entries(obj).filter(([, v]) => v !== undefined && v !== null && v !== '' && v !== false)
    );
}
